<template>
  <span class="rf-web-checkbox" :id='"rf-qtip-" + cpntId'>
    <input type="checkbox" :id='cpntId' v-model='value' :disabled='cpntDisabled'>
    <label :for='cpntId' :tabIndex='cpntTabIndex' :class='"has-" + cpntMensagemTipo' @keyup='onKeyUp'>
      <span v-html='cpntNome'></span>

      <!-- <RF-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
        :cpntId='cpntId + "-explica"' 
        :cpntTitle='cpntExplica.mensagem'
        :cpntPositionMy='cpntExplica.posicaoMy'
        :cpntPositionAt='cpntExplica.posicaoAt'
        :cpntClasses='cpntExplica.class'

        style='vertical-align: 0px;'
      ></RF-Explica> -->
    </label>
    <span v-if='cpntMensagem !== "" && cpntMensagem !== null' v-html='cpntMensagem' :class='"has-" + cpntMensagemTipo'></span>
  </span>
</template>

<style scoped>
  /* -------------- rf-web-checkbox ------------- */
  .rf-web-checkbox > input[type=checkbox] {
    display: none;
  }
  .rf-web-checkbox > input[type=checkbox] + label {
    margin: 3px;
  }
  .rf-web-checkbox > input[type=checkbox] + label:before {
    content: "";  
    display: inline-block;  
    width: 22px;  
    height: 22px;
    vertical-align: middle;
    background-color: #fff;  
    border-radius: 2px;  
    border: 1px solid #c9d3dd;

    cursor: pointer;
  }
  .rf-web-checkbox > input[type=checkbox]:checked + label:before {
    content: "\2714";
    color: var(--color-base-03);
    background-color: #F0F0F0; 
    text-align: center;
    line-height: 20px;
    text-shadow: 0px 0px 3px #eee;

    font-size: var(--font-base-soma-14);
  }
  .rf-web-checkbox > input[type=checkbox]:checked:disabled + label:before {
    content: "\2714";
    color: #ccc;
    background-color: #F0F0F0; 
    text-align: center;
    text-shadow: 0px 0px 3px #eee;

    opacity: 0.6;
  }
  .rf-web-checkbox > input[type=checkbox]:disabled + label span {
    color: var(--color-base-02);
    opacity: 0.8;
  }
  .rf-web-checkbox > input[type=checkbox]:disabled + label:before {
    content: "";  
    display: inline-block;  
    width: 22px;  
    height: 22px;
    vertical-align: middle;
    background-color: #F0F0F0;  
    border-radius: 2px;  
    border: 1px solid #c9d3dd;

    opacity: 0.8;
  }
/* ------------------------------------------------------------------------------- */
</style>

<script>
  export default {
    name: 'rf-web-checkbox',
    props: {
      cpntStatus: {
        required: true
      },
      cpntTime: {
        required: false,
        type: [ String, Number ]
      },
      cpntId: {
        required: true,
        type: String
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntTabIndex: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return 1
        }
      },
      cpntValue: {
        required: true,
        type: [ String, Number ]
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntExplica: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntChecked: {
        type: Array,
        required: true,
        default: function () {
          return []
        }
      },
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        value: false,
        flag: false
      }
    },
    mounted: function () {
      // SETA FLAG SE O VALOR ESTA MARCADO
      this.flag = this.cpntChecked.filter(item => item === this.cpntValue).length !== 0

      // CHAMA A FUNÇÃO PARA VERIFICAR SE O CHECKBOX ESTA MARCADO
      this.onCheckMarcado()

      // CHAMA A FUNÇÃO PARA CRIAR O QTIP
      this.criarQtipButton()
    },
    methods: {
      onCheckMarcado: function () {
        this.value = this.cpntChecked.filter(item => item === this.cpntValue).length !== 0
      },
      criarQtipButton: function () {
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        var self = this

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // DESTROI O QTIP SE ELE EXISITR
        $('#rf-qtip-' + self.cpntId).qtip('destroy', true)

        if (self.cpntExplica !== null) {
          var chavesIniciais = {
            mensagem: '',
            titulo: 'Rotina Fácil',
            positionMy: 'top left',
            positionAt: 'bottom right',
            classes: 'rf-qtip'
          }

          // SETA OS VALOORE E PADROES PARA O QTIP
          for (var key in chavesIniciais) {
            if (!self.cpntExplica.hasOwnProperty(key)) {
              self.cpntExplica[key] = chavesIniciais[key]
            }
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          setTimeout(function () {
            $('#rf-qtip-' + self.cpntId).qtip({
              // content: self.cpntExplica.mensagem,
              content: {
                text: self.cpntExplica.mensagem,
                title: self.cpntExplica.titulo
              },
              position: {
                my: self.cpntExplica.positionMy,
                at: self.cpntExplica.positionAt
              },
              style: {
                classes: self.cpntExplica.classes
              }
            })
          }, 300)
        }
      },
      onKeyUp: function (event) {
        switch (event.key) {
          case 'Enter':
            this.value = !this.value
            break
        }
      }
    },
    watch: {
      'value': function () {
        if (this.flag !== this.value) { // VERIFICA SE DEVE ATUALIZAR O COMPONENT
          this.cpntOnChange(this.value, this.cpntId)
        }
      },
      'cpntExplica': function () {
        this.criarQtipButton()
      },
      cpntChecked: function () {
        // SETA FLAG SE O VALOR ESTA MARCADO
        this.flag = this.cpntChecked.filter(item => item === this.cpntValue).length !== 0

        // CHAMA A FUNÇÃO PARA VERIFICAR SE O CHECKBOX ESTA MARCADO
        this.onCheckMarcado()
      },
      cpntTime: function () {
        // SETA FLAG SE O VALOR ESTA MARCADO
        this.flag = this.cpntChecked.filter(item => item === this.cpntValue).length !== 0

        // CHAMA A FUNÇÃO PARA VERIFICAR SE O CHECKBOX ESTA MARCADO
        this.onCheckMarcado()
      }
    }
  }
</script>
